module.exports = __webpack_public_path__ + "img/circle-check-subscribtion-plan.bcc8bbaf.svg";